export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const TOKEN_VALID = "TOKEN_VALID";
export const TOKEN_INVALID = "TOKEN_INVALID";

export const SET_MESSAGE_LOGIN_SUCCESS = "SET_MESSAGE_LOGIN_SUCCESS";
export const SET_MESSAGE_LOGIN_FAIL = "SET_MESSAGE_LOGIN_FAIL";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SET_KONFIGURASI_MENU = "SET_KONFIGURASI_MENU";
export const SET_MASTER_MENU = "SET_MASTER_MENU";

export const SET_PUBLISHER_ID = "SET_PUBLISHER_ID";

export const GET_TENTANG_KAMI_TEXT = "GET_TENTANG_KAMI_TEXT";
export const GET_VISI_KAMI_TEXT = "GET_VISI_KAMI_TEXT";
export const GET_DSP_NAME = "GET_DSP_NAME";
export const GET_DSP_LOGO = "GET_DSP_LOGO";
export const SET_IMAGE_TENTANG_KAMI_1 = "SET_IMAGE_TENTANG_KAMI_1";
export const SET_IMAGE_TENTANG_KAMI_2 = "SET_IMAGE_TENTANG_KAMI_2";
export const SET_IMAGE_VISI_KAMI_1 = "SET_IMAGE_VISI_KAMI_1";
export const SET_IMAGE_VISI_KAMI_2 = "SET_IMAGE_VISI_KAMI_2";
export const SET_IMAGE_PUBLISHER_1 = "SET_IMAGE_PUBLISHER_1";
export const SET_IMAGE_PUBLISHER_2 = "SET_IMAGE_PUBLISHER_2";
export const SET_IMAGE_PUBLISHER_3 = "SET_IMAGE_PUBLISHER_3";
export const SET_IMAGE_PUBLISHER_4 = "SET_IMAGE_PUBLISHER_4";
export const SET_IMAGE_PUBLISHER_5 = "SET_IMAGE_PUBLISHER_5";
export const SET_IMAGE_PUBLISHER_6 = "SET_IMAGE_PUBLISHER_6";


export const GET_IMAGE_TENTANG_KAMI_1 = "GET_IMAGE_TENTANG_KAMI_1";
export const GET_IMAGE_TENTANG_KAMI_2 = "GET_IMAGE_TENTANG_KAMI_2";
export const GET_IMAGE_VISI_KAMI_1 = "GET_IMAGE_TENTANG_KAMI_1";
export const GET_IMAGE_VISI_KAMI_2 = "GET_IMAGE_TENTANG_KAMI_2";
export const GET_IMAGE_PUBLISHER_1 = "GET_IMAGE_TENTANG_KAMI_1";
export const GET_IMAGE_PUBLISHER_2 = "GET_IMAGE_TENTANG_KAMI_2";
export const GET_IMAGE_PUBLISHER_3 = "GET_IMAGE_TENTANG_KAMI_3";
export const GET_IMAGE_PUBLISHER_4 = "GET_IMAGE_TENTANG_KAMI_4";
export const GET_IMAGE_PUBLISHER_5 = "GET_IMAGE_TENTANG_KAMI_5";
export const GET_IMAGE_PUBLISHER_6 = "GET_IMAGE_TENTANG_KAMI_6";

export const GET_IMAGE_COVER_BERITA_PUBLISHER = "GET_IMAGE_COVER_BERITA_PUBLISHER";

export const SET_VALUE_BERITA_DAN_IKLAN = "SET_VALUE_BERITA_DAN_IKLAN";
export const DELETE_VALUE_BERITA_DAN_IKLAN = "DELETE_VALUE_BERITA_DAN_IKLAN";
export const DELETE_ALL_VALUES_BERITA_DAN_IKLAN = "DELETE_ALL_VALUES_BERITA_DAN_IKLAN";

export const SET_VALUE_WEB_MANAGEMENT = "SET_VALUE_WEB_MANAGEMENT";
export const DELETE_ALL_VALUES_WEB_MANAGEMENT = "DELETE_ALL_VALUES_WEB_MANAGEMENT";

export const SET_USERLOGIN = "SET_USERLOGIN";
export const SET_USERLOGOUT = "SET_USERLOGOUT";

export const SET_PARAMS_COMPOSER_AUTHOR = "SET_PARAMS_COMPOSER_AUTHOR";
export const CLEAR_PARAMS_COMPOSER_AUTHOR = "CLEAR_PARAMS_COMPOSER_AUTHOR";
export const GET_PARAMS_COMPOSER_AUTHOR = "GET_PARAMS_COMPOSER_AUTHOR";
export const SET_BULK_PARAMS_COMPOSER_AUTHOR = "SET_BULK_PARAMS_COMPOSER_AUTHOR";

export const SET_PARAMS_PERFORMER = "SET_PARAMS_PERFORMER";
export const CLEAR_PARAMS_PERFORMER = "CLEAR_PARAMS_PERFORMER";
export const GET_PARAMS_PERFORMER = "GET_PARAMS_PERFORMER";
export const SET_BULK_PARAMS_PERFORMER = "SET_BULK_PARAMS_PERFORMER";

export const SET_PARAMS_SONG = "SET_PARAMS_SONG";
export const CLEAR_PARAMS_SONG = "CLEAR_PARAMS_SONG";
export const GET_PARAMS_SONG = "GET_PARAMS_SONG";
export const SET_BULK_PARAMS_SONG = "SET_BULK_PARAMS_SONG";

export const SET_PARAMS_CLIENT = "SET_PARAMS_CLIENT";
export const CLEAR_PARAMS_CLIENT = "CLEAR_PARAMS_CLIENT";
export const GET_PARAMS_CLIENT = "GET_PARAMS_CLIENT";
export const SET_BULK_PARAMS_CLIENT = "SET_BULK_PARAMS_CLIENT";

export const SET_PARAMS_USER = "SET_PARAMS_USER";
export const CLEAR_PARAMS_USER = "CLEAR_PARAMS_USER";
export const GET_PARAMS_USER = "GET_PARAMS_USER";
export const SET_BULK_PARAMS_USER = "SET_BULK_PARAMS_USER";

export const SET_PARAMS_AGENT = "SET_PARAMS_AGENT";
export const CLEAR_PARAMS_AGENT = "CLEAR_PARAMS_AGENT";
export const GET_PARAMS_AGENT = "GET_PARAMS_AGENT";
export const SET_BULK_PARAMS_AGENT = "SET_BULK_PARAMS_AGENT";

export const SET_PARAMS_CLIENT_CLASSIFICATION = "SET_PARAMS_AGENT";
export const CLEAR_PARAMS_CLIENT_CLASSIFICATION = "CLEAR_PARAMS_CLIENT_CLASSIFICATION";
export const GET_PARAMS_CLIENT_CLASSIFICATION = "GET_PARAMS_CLIENT_CLASSIFICATION";
export const SET_BULK_PARAMS_CLIENT_CLASSIFICATION = "SET_BULK_PARAMS_CLIENT_CLASSIFICATION";

export const SET_PARAMS_GROUP = "SET_PARAMS_GROUP";
export const CLEAR_PARAMS_GROUP = "CLEAR_PARAMS_GROUP";
export const GET_PARAMS_GROUP = "GET_PARAMS_GROUP";
export const SET_BULK_PARAMS_GROUP = "SET_BULK_PARAMS_GROUP";

export const SET_PARAMS_ADVANCED = "SET_PARAMS_ADVANCED";
export const CLEAR_PARAMS_ADVANCED = "CLEAR_PARAMS_ADVANCED";
export const GET_PARAMS_ADVANCED = "GET_PARAMS_ADVANCED";
export const SET_BULK_PARAMS_ADVANCED = "SET_BULK_PARAMS_ADVANCED";

export const SET_PARAMS_SALES_INVOICE = "SET_PARAMS_SALES_INVOICE";
export const CLEAR_PARAMS_SALES_INVOICE = "CLEAR_PARAMS_SALES_INVOICE";
export const GET_PARAMS_SALES_INVOICE = "GET_PARAMS_SALES_INVOICE";
export const SET_BULK_SALES_INVOICE = "SET_BULK_SALES_INVOICE";

export const SET_PARAMS_COMPOSER_INVOICE = "SET_PARAMS_COMPOSER_INVOICE";
export const CLEAR_PARAMS_COMPOSER_INVOICE = "CLEAR_PARAMS_COMPOSER_INVOICE";
export const GET_PARAMS_COMPOSER_INVOICE = "GET_PARAMS_COMPOSER_INVOICE";
export const SET_BULK_COMPOSER_INVOICE = "SET_BULK_COMPOSER_INVOICE";

export const SET_PARAMS_PAYMENT = "SET_PARAMS_PAYMENT";
export const CLEAR_PARAMS_PAYMENT = "CLEAR_PARAMS_PAYMENT";
export const GET_PARAMS_PAYMENT = "GET_PARAMS_PAYMENT";
export const SET_BULK_PAYMENT = "SET_BULK_PAYMENT";

export const SET_PARAMS_LOAN = "SET_PARAMS_LOAN";
export const CLEAR_PARAMS_LOAN = "CLEAR_PARAMS_LOAN";
export const GET_PARAMS_LOAN = "GET_PARAMS_LOAN";
export const SET_BULK_LOAN = "SET_BULK_LOAN";

export const SET_PARAMS_COST_ALLOCATION = "SET_PARAMS_COST_ALLOCATION";
export const CLEAR_PARAMS_COST_ALLOCATION = "CLEAR_PARAMS_COST_ALLOCATION";
export const GET_PARAMS_COST_ALLOCATION = "GET_PARAMS_COST_ALLOCATION";
export const SET_BULK_COST_ALLOCATION = "SET_BULK_COST_ALLOCATION";

export const SET_PARAMS_UPLOAD = "SET_PARAMS_UPLOAD";
export const CLEAR_PARAMS_UPLOAD = "CLEAR_PARAMS_UPLOAD";
export const GET_PARAMS_UPLOAD = "GET_PARAMS_UPLOAD";
export const SET_BULK_UPLOAD = "SET_BULK_UPLOAD";

export const SET_PARAMS_ADVANCE_COMPOSER = "SET_PARAMS_ADVANCE_COMPOSER";
export const CLEAR_PARAMS_ADVANCE_COMPOSER = "CLEAR_PARAMS_ADVANCE_COMPOSER";
export const GET_PARAMS_ADVANCE_COMPOSER = "GET_PARAMS_ADVANCE_COMPOSER";
export const SET_BULK_ADVANCE_COMPOSER = "SET_BULK_ADVANCE_COMPOSER";

export const SET_PARAMS_BALANCE = "SET_PARAMS_BALANCE";
export const CLEAR_PARAMS_BALANCE = "CLEAR_PARAMS_BALANCE";
export const GET_PARAMS_BALANCE = "GET_PARAMS_BALANCE";
export const SET_BULK_BALANCE = "SET_BULK_BALANCE";

export const SET_PARAMS_EXCHANGE_RATE = "SET_PARAMS_EXCHANGE_RATE";
export const CLEAR_PARAMS_EXCHANGE_RATE = "CLEAR_PARAMS_EXCHANGE_RATE";
export const GET_PARAMS_EXCHANGE_RATE = "GET_PARAMS_EXCHANGE_RATE";
export const SET_BULK_EXCHANGE_RATE = "SET_BULK_EXCHANGE_RATE";

export const SET_PARAMS_NEWS_AND_ADS = "SET_PARAMS_NEWS_AND_ADS";
export const CLEAR_PARAMS_NEWS_AND_ADS = "CLEAR_PARAMS_NEWS_AND_ADS";
export const GET_PARAMS_NEWS_AND_ADS = "GET_PARAMS_NEWS_AND_ADS";
export const SET_BULK_NEWS_AND_ADS = "SET_BULK_NEWS_AND_ADS";

export const SET_FILTER_OPTIONS = "SET_FILTER_OPTIONS";
export const CLEAR_FILTER_OPTIONS = "CLEAR_FILTER_OPTIONS";